// extracted by mini-css-extract-plugin
export default {"pageWrap":"qb-z","fullWidth":"rb-z","heading":"sb-z","fullBleed":"tb-z","hidden":"ub-z"};